import type {
  DiscountT,
  OfferPricingTypeT,
  OfferVehicleAvailabilityT,
  OfferVehicleConditionT,
  OfferVehicleGearboxT,
  TruckFuelTypeT,
} from "@/app/types/offers";

// DISCOUNT
export const DISCOUNT_TYPE_OPTIONS: {
  value: DiscountT["type"];
  label: string;
}[] = [
  { value: "absolute", label: "Absolutbetrag (€)" },
  { value: "percent", label: "Prozentsatz (%)" },
];

export const DISCOUNT_APPLIED_ON_OPTIONS = [
  { value: "netto", label: "Netto" },
  { value: "brutto", label: "Brutto" },
] as { value: string; label: string }[];

export const DEFAULT_DISCOUNT_VALUE = {
  enabled: true,
  type: "absolute" as const,
  appliedOn: "netto" as const,
  value: null as number | null,
  description: "",
};

// CONSUMPTION
export const CO2_LABEL_OPTIONS = [
  { value: "A", label: "A" },
  { value: "B", label: "B" },
  { value: "C", label: "C" },
  { value: "D", label: "D" },
  { value: "E", label: "E" },
  { value: "F", label: "F" },
  { value: "G", label: "G" },
];

// PRICING
export const OFFER_PRICING_TYPE_OPTIONS: {
  value: OfferPricingTypeT;
  label: string;
}[] = [
  { value: "", label: "Typ wählen..." },
  { value: "barkauf", label: "Barkauf" },
  { value: "leasing", label: "Leasing" },
  { value: "finanzierung", label: "Finanzierung" },
];

// AVAILABILITY
export const OFFER_VEHICLE_AVAILABILITY_OPTIONS: {
  value: OfferVehicleAvailabilityT;
  label: string;
}[] = [
  { value: "in_stock", label: "Sofort verfügbar" },
  { value: "order", label: "Bestellfahrzeug" },
];

// CONDITION
export const OFFER_VEHICLE_CONDITION_OPTIONS: {
  value: OfferVehicleConditionT;
  label: string;
}[] = [
  { value: "new", label: "Neuwagen" },
  { value: "used", label: "Gebrauchtwagen" },
];

// GEARBOX
export const OFFER_VEHICLE_GEARBOX_OPTIONS: {
  value: OfferVehicleGearboxT;
  label: string;
}[] = [
  { value: "automatic", label: "Automatik" },
  { value: "manual", label: "Schaltgetriebe" },
];

// EURONORM
export const EURONORM_OPTIONS: {
  value: string;
  label: string;
}[] = [
  { value: "Euro 1", label: "Euro 1" },
  { value: "Euro 2", label: "Euro 2" },
  { value: "Euro 3", label: "Euro 3" },
  { value: "Euro 4", label: "Euro 4" },
  { value: "Euro 5", label: "Euro 5" },
  { value: "Euro 5a", label: "Euro 5a" },
  { value: "Euro 5b", label: "Euro 5b" },
  { value: "Euro 6", label: "Euro 6" },
  { value: "Euro 6e", label: "Euro 6e" },
  { value: "Euro 6b", label: "Euro 6b" },
  { value: "Euro 6c", label: "Euro 6c" },
  { value: "Euro 6d-TEMP", label: "Euro 6d-TEMP" },
  { value: "Euro 6d", label: "Euro 6d" },
];

// TRUCK FUEL TYPE (display-only fuel label for LKW offers)
export const TRUCK_FUEL_TYPE_OPTIONS: {
  value: TruckFuelTypeT;
  label: string;
}[] = [
  { value: "electric", label: "Elektro" },
  { value: "diesel", label: "Diesel" },
  { value: "gasoline", label: "Benzin" },
  { value: "hybrid", label: "Hybrid" },
];
